import { createApp, h, App as VueApp } from 'vue';
import GlobalsPlugin from '@/utils/vue-globals';
import App from '@/presentation/App.vue';
import { IInlineSearchApplication, RenderInlineSearchCommand } from '@studyportals/inlinesearch-interfaces';


export class InLineSearchApplication implements IInlineSearchApplication {
	render(command: RenderInlineSearchCommand): void {
		const { node } = command;

		if (!node) return;

		this.mountVueApplication(node);
	}

	private mountVueApplication(node: HTMLElement): void {
		try {
			const inLineSearchVueApp: VueApp = createApp({
				render: () =>
					h(App)
			});

			inLineSearchVueApp.use(GlobalsPlugin);
			inLineSearchVueApp.mount(node);
		} catch {
			// ignored
		}
	}
}